import { connect } from 'react-redux'

import { processEmailQuery } from 'store/entities/identity/actions'
import { Launch } from './Launch'

const mapDispatchToProps = {
  processEmailQuery,
}

export default connect(null, mapDispatchToProps)(Launch)
